module.exports = __webpack_public_path__ + "img/coffeeShop.d8f62bc6.png";